import { computed, inject, isSignal } from '@angular/core';

import { TicketsChatService } from '@core/ask-hr-tickets-logic';
import { AskHrChatFeatureId } from '@core/ask-hr-types';
import { injectPreviewAskEnabled } from '@core/intelligence-contracts';
import { HrAssistantConfigDataService } from '@core/intelligence-logic';
import { provideHrAssistantFeature } from '@core/intelligence-smart-ui';

import { ChatUserTicketsViewComponent } from './chat-user-tickets-view/chat-user-tickets-view.component';
import { TicketsWelcomeComponent } from './tickets-welcome.component';

export const CHAT_TICKETS_LIST_FEATURE = provideHrAssistantFeature({
  useValue: {
    id: AskHrChatFeatureId.Tickets,
    welcomeCmp: TicketsWelcomeComponent,
    welcomeCmpVisible: () => {
      const hrAssistantConfigDataService = inject(HrAssistantConfigDataService);
      const ticketsChatService = inject(TicketsChatService);
      const askHrPreview = injectPreviewAskEnabled({ optional: true });
      hrAssistantConfigDataService.fetchIfNotLoaded();
      const ticketsFeatureAvailable = ticketsChatService.isFeatureAvailable();
      return computed(() => {
        if (!ticketsFeatureAvailable()) return false;

        return isSignal(askHrPreview)
          ? askHrPreview()
          : (hrAssistantConfigDataService.configData()?.ask.enabled ?? false);
      });
    },
    activateCmp: ChatUserTicketsViewComponent,
  },
});
